import { useState } from 'react';
import Modal from 'react-modal';
import { Button } from 'library/components/common';
import { useAppSelector } from 'library/hooks/common';
import { useShare } from 'library/hooks/events';
import { selectShareId } from 'library/redux/events';
import { ModalSuccess } from './frames';
import * as st from './ModalEventShare.module.scss';
import { IconButton, Textarea } from '@shared/ui';
import { Close } from '@shared/assets';

const ModalEventShare: React.FC = () => {
  const id = useAppSelector(selectShareId);
  const [isModalSuccess, setIsModalSuccess] = useState(false);
  const { isOpen, closeShare } = useShare();
  const shareLink = `${window.location.origin}/events/events/${id}`;

  const closeModal = () => {
    isOpen && closeShare();
  };

  const onClick = () => {
    navigator.clipboard.writeText(shareLink);
    setIsModalSuccess(true);
  };

  return (
    <Modal
      isOpen={true}
      className={st.shareModal}
      overlayClassName={st.shareModal__overlay}
      onRequestClose={closeModal}
      ariaHideApp={false}
    >
      <div className={st.shareModal__header}>
        <IconButton className={st.closeBtn} onClick={closeModal}>
          <Close />
        </IconButton>
        <p>Поделиться мероприятием</p>
      </div>
      <div className={st.shareModal__body}>
        <Textarea value={shareLink} />
        <p>Скопируйте и отправьте ссылку удобным для Вас способом.</p>
        <Button handler={onClick} className={st.copy}>
          Копировать ссылку
        </Button>
      </div>
      <ModalSuccess isOpen={isModalSuccess} closeModalSuccess={closeModal} timer={3000} />
    </Modal>
  );
};

export default ModalEventShare;
